import React from 'react'
import { ChoiceList } from 'hhsoig-design-system-core'
import { normalizeIHSVictimData } from '../../utilities/methods/normalizeIHSVictimData'
import { formatPersonName } from '../../utilities/methods/formatter'
import { getErrorMessage } from '../../utilities/methods/getErrorMessage'

export const createVictimChoices = (values, fieldName) =>
  normalizeIHSVictimData(values, 9).map(choice => {
    const { first_name, middle_name, last_name, suffix, uuid } = choice
    return {
      checked: values[fieldName].includes(uuid),
      label: formatPersonName(first_name, middle_name, last_name, suffix),
      value: uuid
    }
  })

export class IHSVictimChoiceField extends React.Component {
  static getDerivedStateFromProps(props) {
    const { errors, fieldName, touched, value, values } = props
    const formikValue = value || values[fieldName]
    const choiceOptions = createVictimChoices(values, fieldName)
    const errorMessage = getErrorMessage({ errors, name: fieldName, touched })
    return {
      choices: choiceOptions,
      errorMessage,
      value: formikValue && formikValue.length > 0 ? formikValue : []
    }
  }

  state = {
    choices: [],
    errorMessage: null,
    value: []
  }

  _handleCheckboxChange = e => {
    const { setFieldValue } = this.props
    const newValue = e.target.checked
      ? this.state.value.concat([e.target.value]).sort()
      : this.state.value.filter(v => v !== e.target.value).sort()

    return setFieldValue(this.props.fieldName, newValue)
  }

  render() {
    const { label, labelClassName, hint, fieldName } = this.props

    return (
      <ChoiceList
        choices={this.state.choices}
        label={label}
        labelClassName={labelClassName}
        name={fieldName}
        hint={hint}
        errorMessage={this.state.errorMessage}
        type="checkbox"
        value={this.state.value}
        onChange={this._handleCheckboxChange}
      />
    )
  }
}
